(function (once, Drupal) {
  Drupal.behaviors.shareBehavior = {
    attach: function (context, settings) {
      once('shareBehavior', 'button.share', context).forEach(
        function (element) {
          const shareData = {
            title: element.dataset.title,
            url: element.dataset.url,
            text: element.dataset.text,
          };

          if (navigator.share && navigator.canShare(shareData)) {
            element.style.display = 'block';
            element.addEventListener('click', async () => {
              try {
                await navigator.share(shareData);
              } catch (err) {
                console.error(err);
              }
            });
          }
        }
      );
    },
  };
})(once, Drupal);
